export default "__VITE_ASSET__43923a07__"